import { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from '@omnea-app/packages/universal/general/observability/withErrorCapture'
import { ServiceUrls } from '@omnea-app/packages/universal/general/serviceUrls'
import { RequestTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import { Flatten } from '@omnea-app/packages/universal/utility-types/utilityTypes'
import { paths } from './requestsGeneratedTypes'

interface Params {
  authorization: string
}

export type Request = paths['/{id}']['get']['responses']['200']['content']['application/json']
export type RequestListItem = Extract<
  paths['/paginated']['post']['responses']['200']['content']['application/json'],
  {
    totalCount: number
  }
>['requests'][number]
export type RequestPriority =
  paths['/{id}']['get']['responses']['200']['content']['application/json']['derivedFields']['priority']
export type RequestBlockInfo =
  paths['/{id}/request-blocks-info/']['get']['responses']['200']['content']['application/json'][number]

type OpenApiRequestFormParticipants =
  paths['/request-form/{requestFormId}/participants']['get']['responses']['200']['content']['application/json']

// This type mostly relies on OpenApi generated types except for the request.type is it's enum
export type RequestFormParticipants = Flatten<
  Omit<OpenApiRequestFormParticipants, 'request'> & { request: { id: string; type: RequestTypeEnum } }
>
export class RequestsHttpClient {
  GET
  POST
  constructor({ authorization }: Params) {
    const { GET, POST } = createClient<paths>({
      baseUrl: ServiceUrls.REQUESTS,
      headers: { Authorization: authorization },
    })
    this.GET = withErrorCapture({ method: GET })
    this.POST = withErrorCapture({ method: POST })
  }
}

export type RequestResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
export type RequestsApiRequestBody<TPath extends keyof paths, TMethod extends keyof paths[TPath]> = GenericRequestBody<
  paths,
  TPath,
  TMethod
>
